module.exports = __webpack_public_path__ + "static/media/bh.f07499f0.svg";